<template>
    <section id="packages-container">
        <nav>
            <div class="packages-kanban-search">
                <input type="text" v-model="search" placeholder="Search Packages..."
                       v-on:input="debounceSearchForPackagesOnMap"/>
            </div>
            <div class="packages-kanban-filters">
                <a @click.prevent="activateFilter('active')" :class="{ active: filters.active }" href="#">Active</a>
                <a @click.prevent="activateFilter('deleted')" :class="{ active: filters.deleted }" href="#">Deleted</a>
                <a @click.prevent="activateFilter('unable_to_quote')" :class="{ active: filters.unable_to_quote }"
                   href="#">Unable To Quote</a>
                <a @click.prevent="activateFilter('dead')" :class="{ active: filters.dead }" href="#">Dead</a>
                <a @click.prevent="activateFilter('archived')" :class="{ active: filters.archived }"
                   href="#">Archived</a>
                <a @click.prevent="activateFilter('defects')" :class="{ active: filters.defects }" href="#">Defects</a>
                <a @click.prevent="activateFilter('hold')" :class="{ active: filters.hold }" href="#">On Hold</a>
                <a @click.prevent="activateFilter('all')" :class="{ active: filters.all }" href="#">All</a>
            </div>
        </nav>
        <main id="packages-map-area">
            <nav>
                <div class="packages-map-search">
                    <input type="text" v-model="address_search" placeholder="Search Map..."
                           v-on:keyup.enter="debounceSearchForMap"/>
                </div>
                <div class="packages-map-filters">
                    <a v-for="statusId in status_ids" @click.prevent="limitResultsToStatus(statusId)"
                       :class="{ active: mapResultsStatus == statusId }" href="#">{{ getPackageStatusNameById(statusId)
                        }}</a>
                </div>
            </nav>
            <div id="map"></div>
        </main>
    </section>
</template>

<script>
    import GoogleMapsLoader from 'google-maps'

    export default {
        props: ['mapskey', 'mapsgeokey'],
        data() {
            return {
                packages: [],
                filters: {
                    all: null,
                    active: true,
                    deleted: null,
                    unable_to_quote: null,
                    dead: null,
                    archived: null,
                    defects: null,
                    on_hold: null
                },
                mapResultsStatus: 600,
                address_search: '',
                search: '',
                googleMap: null,
                status_map: {
                    100: 'New Enquiry',
                    200: 'Quoting',
                    300: 'Quoted',
                    400: 'Secured',
                    500: 'Booked',
                    600: 'In Progress',
                    700: 'Complete',
                }
            }
        },
        computed: {
            status_ids: function () {
                return this.getStatusIds();
            },
            statusFilteredPackages: function () {
                return this.filterPackagesBasedOnPreferences(this.packages);
            },
            mapResults: function () {
                var that = this;
                var filteredPackages = _.filter(this.packages, function (package_) {
                    var validStatus = package_.status.id == that.mapResultsStatus;
                    if (!validStatus) {
                        return false;
                    }

                    return package_.has_coordinates;
                });

                return this.filterPackagesBasedOnPreferences(filteredPackages);
            }
        },
        methods: {
            limitResultsToStatus: function (status) {
                this.mapResultsStatus = status;
                this.setupMap();
            },
            debounceSearchForPackagesOnMap: _.debounce(function (e) {
                this.setupMap();
            }, 500),
            debounceSearchForMap: _.debounce(function (e) {
                var vueInstance = this;
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                        var results = JSON.parse(xmlHttp.responseText);
                        vueInstance.googleMap.setCenter(results.results[0].geometry.location);
                        vueInstance.googleMap.setZoom(18);
                    }
                }
                xmlHttp.open("GET", 'https://maps.googleapis.com/maps/api/geocode/json?address=' + this.address_search + '&key=' + this.mapsgeokey, true); // true for asynchronous
                xmlHttp.send(null);
            }, 500),
            activateFilter: function (filterName) {
                var that = this;
                _.forOwn(this.filters, function (value, key) {
                    that.filters[key] = null;
                });
                this.filters[filterName] = true;
                this.setupMap();
            },
            getPackageStatusNameById: function (status) {
                return this.status_map[status];
            },
            getPackagesByStatus: function (status) {
                var filteredPackages = _.filter(this.statusFilteredPackages, function (package_) {
                    return package_.status.id == status;
                });

                return filteredPackages;
            },
            filterPackagesBasedOnPreferences: function (packages) {
                var that = this;
                var filtersToProcess = ['active', 'deleted', 'unable_to_quote', 'dead', 'archived', 'defects', 'hold'];

                // This loop doesn't support more than one filter being run at a time.
                // Probably very easy to make it support multiple.
                var filteredPackages = packages;
                filtersToProcess.forEach(function (filterName) {
                    if (that.filters[filterName] === true) {
                        // By this point we've found something we want to filter all packages against.
                        // Let's filter them based on the filter key and return out.
                        // We can't do a simple return out of here because Javascript is fucking shit.
                        filteredPackages = _.filter(packages, function (package_) {
                            if (filterName == 'active') {
                                return package_.meta.inactive === false;
                            }
                            return package_.meta[filterName] === true;
                        });
                    }
                });

                // Run a text search on specific fields
                if (this.search != '') {
                    var checkMatchProperties = ['name', 'address'];
                    var searchString = this.search.toLowerCase();
                    filteredPackages = _.filter(filteredPackages, function (package_) {
                        if (package_.name.toLowerCase().indexOf(searchString) != -1) {
                            return true;
                        } else {
                            if (package_.address.toLowerCase().indexOf(searchString) != -1) {
                            } else {
                                return false;
                            }
                        }
                    });
                }

                return filteredPackages;
            },
            getPackages: function (statusId) {
                var that = this;
                var parameters = {
                    status_id: statusId
                };
                axios.get(appUrls.packages.index, {params: parameters})
                    .then(response => {
                        that.packages = that.packages.concat(_.orderBy(response.data.data, ['id'], ['asc']));
                        that.setupMap();
                    });
            },
            getStatusIds: function () {
                return Object.keys(this.status_map);
            },
            setupMap: function () {
                var vueInstance = this;

                GoogleMapsLoader.release(function () {
                });

                GoogleMapsLoader.KEY = vueInstance.mapskey;

                GoogleMapsLoader.load(function (google) {

                    var bounds = new google.maps.LatLngBounds();

                    vueInstance.googleMap = new google.maps.Map(document.getElementById('map'), {
                        zoom: 3,
                        center: {lat: -28.024, lng: 140.887}
                    });

                    var markers = vueInstance.mapResults.map(function (package_, i) {
                        var newMarker = new google.maps.Marker({
                            position: {lat: package_.latitude, lng: package_.longitude},
                            title: package_.name
                        });

                        bounds.extend(newMarker.position);

                        var contentString = '<div id="content">' +
                            '<h1 id="firstHeading" class="firstHeading">' + package_.name + '</h1>' +
                            '<div id="bodyContent">' +
                            '<p>' + package_.address + '</p>' +
                            '<p><a href="' + package_._links.frontend.view + '">' + 'Go To Package</a></p>' +
                            '</div>' +
                            '</div>';

                        var infowindow = new google.maps.InfoWindow({
                            content: contentString
                        });

                        newMarker.addListener('click', function () {
                            infowindow.open(vueInstance.googleMap, newMarker);
                        });

                        return newMarker;
                    });

                    vueInstance.googleMap.fitBounds(bounds);

                    var markerCluster = new MarkerClusterer(vueInstance.googleMap, markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});

                })
            }
        },
        mounted() {
            var that = this;

            // Loop through each possible status and get them individually rather than one whole big batch
            // Should be nicer to see stuff just popping in.
            _.forEach(that.getStatusIds(), function (statusId) {
                that.getPackages(statusId);
            });
        }
    }
</script>

<style lang="scss" scoped>
    #map {
        width: calc(100% - 2em);
        height: 700px;
        display: block;
        margin: 0 auto;
        border-radius: $standardBorderRadius;
    }

    $kanban-grid: (
            columns: 7,
            gutter: 20px,
            media: 'screen'
    );

    #packages-container {
        @include grid-container();
        @include grid-collapse();
        nav {
            display: block;
            padding: 0 20px;
            @include clearfix();

            .packages-kanban-filters, .packages-map-filters {
                text-align: left;
                float: left;
            }
            a {
                display: inline-block;
                border-radius: 0.3em;
                font-size: 13px;
                padding: 0.3em 1em;
                text-decoration: none;
                font-weight: 500;
                margin: 0 0 1em 0;
                background-color: #fff;
                color: $brand;
                transition: all 0.1s ease-in-out;
                &:hover, &:active, &.active {
                    background-color: $brand;
                    color: #fff;
                }
            }
            .packages-kanban-search, .packages-map-search {
                float: right;
                input {
                    border: 1px solid #e6e6e6;
                    font-size: 14px;
                    padding: 0.5em 1em;
                    margin-top: -0.1em;
                    font-weight: 500;
                    color: $brand;
                    &::placeholder {
                        color: #8ab7ce;
                    }
                }
            }

            @media (max-width: 900px) {
                .packages-kanban-filters, .packages-map-filters {
                    float: none;
                    display: block;
                    text-align: center;
                }
                .packages-kanban-search, .packages-map-search {
                    float: none;
                    display: block;
                    input {
                        display: block;
                        width: 100%;
                    }
                }

            }

        }
        #packages-map-area {
            nav {
                margin-top: 0;
                padding-top: 0.7em;
                border-top: 1px solid #FFF;
                a {
                    margin-right: 0.5em;
                }
                @media (max-width: 900px) {
                    float: none;
                    display: block;
                    text-align: center;
                }
            }
        }
        #packages-kanban-area > div {
            display: flex;
        }
        @media (max-width: 1419px) {
            #packages-kanban-area {
                overflow-x: scroll;
                padding-bottom: 1em;
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                    background-color: #F5F5F5;
                }

                &::-webkit-scrollbar {
                    height: 10px;
                    background-color: #F5F5F5;
                }

                &::-webkit-scrollbar-thumb {
                    background: $brand -webkit-gradient(linear, 0 0, 0 100%,
                            color-stop(.5, rgba(255, 255, 255, .2)),
                            color-stop(.5, transparent), to(transparent));
                }
                > div {
                    min-width: 1800px;
                }
            }
        }

        #packages-kanban-area > div > div {
            // Force each div to use a custom grid of 7 columns
            // Not concerned with media queries here as we're going to wrap this all up in a scrolly-div
            box-shadow: 3px 4px 4px 0px rgba(0, 0, 0, 0.04);
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            padding: 1em;
            min-height: 400px;
            max-height: 500px;
            overflow-y: scroll;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            @include grid-media($kanban-grid) {
                @include grid-column(1);
            }
            h2 {
                font-size: 19px;
                small {
                    float: right;
                    opacity: 0.4;
                    margin-top: 0.1em;
                }
            }
            ul, li {
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 0.6em;
                padding-bottom: 0.4em;
                border-bottom: 1px dashed rgb(222, 222, 222);
                strong {
                    font-weight: 600;
                }
                @include clearfix();
                &:last-of-type {
                    border-bottom: none;
                    padding-bottom: 0;
                }
                a {
                    text-decoration: none;
                }
                a.client-link {
                    display: block;
                    font-size: 0.9em;
                    color: #8ab7ce;
                    margin-top: 5px;
                    &:hover {
                        color: $brand;
                    }
                }
                .meta-icons {
                    text-align: right;
                    font-size: 14px;
                    color: #8ab7ce;
                    i {
                        margin-left: 8px;
                    }
                }
            }

        }

    }
</style>
